<template>
  <div>
    <h2><u>Wilderness Inn</u></h2>

<SelectButton v-model="value1" :options="options" to="/hours" />


<div class= "HoursOfOperation" v-show="value1 == 'Hours'">
    <p>Hours of operation</p>
    <p><strong><U>Mon-Fri</U></strong></p>
    <p><strong>Breakfast  </strong>07:00 - 09:00</p>
    <p><strong>Lunch  </strong>11:00 - 13:00</p>
    <p><strong>Dinner  </strong>17:00 - 18:30</p>
    <p><strong><U>Sat-Sun</U></strong></p>
    <p><strong>Brunch  </strong>10:00 - 14:00</p>
    <p><strong>Supper  </strong>16:00 - 17:30</p>
    </div>

<div class ="Management" v-show="value1 == 'Management'">
    <h3><u>Manager</u></h3>
    <p><strong>SFC Sugura, Carlos</strong></p>
    <p>907-384-6048</p>
    <h3><u>Assistant Manager</u></h3>
    <p><strong>SSG Ocasio, Luis</strong></p>
    <p>907-384-6048</p>
    <h3><u>Admin NCOIC</u></h3>
    <p><strong>SSG Bonet, Cesar</strong></p>
    <p>907-384-6048</p>
</div>

  </div>
</template>

<script>
import SelectButton from 'primevue/selectbutton';
  export default {
    name: 'Facility',
    components: {
      SelectButton,
    },
        data() {
        return {
            value1: 'Hours',
            value2: null,
            options: ['Hours', 'Management'],
  }
        },
  }
</script>

<style lang="scss" scoped>

</style>